import Icon from '@/assets/icons'
import { FeedItemAccordionItemsType } from '@/types/feed'
import classnames from 'classnames/bind'
import { useState } from 'react'
import styles from './styles.module.scss'

const cx = classnames.bind(styles)

type AccordionProps = {
  items: FeedItemAccordionItemsType[]
  onExpand?: (key: string) => Promise<void>
}

export type LiveFeedItemAccordionProps = Omit<AccordionProps, 'id'>

const Accordion = ({ items, onExpand }: AccordionProps) => {
  const [expandIndex, setExpandIndex] = useState<number | null>(null)

  const toggleItem = async (index: number) => {
    const isExpanded = expandIndex === index

    if (!isExpanded) {
      try {
        await onExpand?.(items[index].key)
      } catch (error) {
        return
      }
    }
    setExpandIndex(isExpanded ? null : index)
  }

  return (
    <div className={cx('accordion')}>
      {items.map((item, index) => (
        <div key={index} className={cx('accordion-item', { open: expandIndex === index })}>
          <button className={cx('accordion-header')} onClick={() => toggleItem(index)}>
            <span className={cx('accordion-header-text')}>{item.header}</span>
            <div className={cx('accordion-header-arrow')}>
              <Icon.AccordionArrow />
            </div>
          </button>
          <div className={cx('accordion-content')}>{item.children}</div>
        </div>
      ))}
    </div>
  )
}

const LiveFeedItemAccordion = ({ items, onExpand }: LiveFeedItemAccordionProps) => {
  return (
    <div onClick={(e) => e.stopPropagation()} className='feed-card-accordion'>
      <Accordion items={items} onExpand={onExpand} />
    </div>
  )
}

export default LiveFeedItemAccordion
